/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InteractionPointPatchData { 
    name?: string;
    type?: InteractionPointPatchData.TypeEnum;
}
export namespace InteractionPointPatchData {
    export type TypeEnum = 'CASHIER' | 'APP' | 'ONLINE';
    export const TypeEnum = {
        CASHIER: 'CASHIER' as TypeEnum,
        APP: 'APP' as TypeEnum,
        ONLINE: 'ONLINE' as TypeEnum
    };
}


